module.exports = __webpack_public_path__ + "img/saude2.070a4c30.svg";